<template>
  <main-page :user="user" color="yellow">
    <template v-slot:title>
      <template v-if="!showFeedback">
        {{ prototype ? "VIEW PROTOTYPE" : "WATCH PITCH" }}
      </template>
      <template v-if="showFeedback">
        PROVIDE {{ prototype ? "PROTOTYPE" : "PITCH" }} FEEDBACK
      </template>
    </template>

    <div :class="{ 'sticky': !prototype }">
      <div class="video" :class="{ 'video-right': showFeedback }">
        <iframe
          v-if="pitch && !isImg(pitch.video)"
          class="video-embed"
          :src="pitch.video"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
        <img
          v-if="pitch && isImg(pitch.video)"
          class="image-embed"
          :src="pitch.video"
        >
        <div v-if="!pitch" class="card p-4">
          <h1>{{ prototype ? "No Prototype Uploaded Yet" : "No Pitch Video Yet" }}</h1>
          <div class="text-md" v-if="!prototype">
            Watch the pitch live and provide contemporaneous feedback
          </div>
          <hr class="my-4" />
          <div class="d-flex flex-row justify-content-center w-100">
            <div class="mr-5">
              <div
                v-if="team"
                class="si-font si-text-yellow"
                style="font-size: 1.75rem; line-height: 1"
              >
                {{ team.name }}
              </div>
              <div class="text-muted">Team</div>
            </div>
            <div>
              <div
                v-if="assignment"
                class="si-font si-text-yellow"
                style="font-size: 1.75rem; line-height: 1"
              >
                {{ assignment.name }}
              </div>
              <div class="text-muted">Assignment</div>
            </div>
          </div>
      </div>
        </div>
        <div class="description"  :class="{ 'description-right': showFeedback }" v-if="pitch && pitch.description" v-html="pitch.description"></div>
      <table v-if="anyScores" class="table">
        <thead>
          <tr class="text-lg">
            <th class="_500" style="opacity: 0.25; width: 50%"></th>
            <th class="_500" style="opacity: 0.25; width: 25%">Score</th>
            <th class="_500" style="opacity: 0.25; width: 25%" v-if="!one_reasoning">
              Feedback
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="cat in rubricCategories">
            <tr
              v-if="cat.response && (cat.response.score != null || cat.response.text)"
              :key="cat.id"
              style="font-size: 2rem"
            >
              <td
                class="v-mid si-font text-left"
                :class="{ [`si-text-${cat.color}`]: true }"
              >
                {{ cat.name }}
              </td>
              <td
                class="v-mid"
                :class="{ [`si-text-${cat.color}`]: true }"
              >
                <span
                  v-if="cat.response.score"
                  class="material-icons"
                  style="font-size: 30px"
                  >check_circle</span
                >
              </td>
              <td
                class="v-mid"
                :class="{ [`si-text-${cat.color}`]: true }"
                v-if="!one_reasoning"
              >
                <span
                  v-if="cat.response.text"
                  class="material-icons"
                  style="font-size: 30px"
                  >check_circle</span
                >
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <div>
      <div class="content">
        <div class="feedback" :class="{ 'video-right': showFeedback }">
          <div class="feedback-wrapper">
            <div v-if="prototype" class="col-12">
              <div
                class="btn btn-full-stripe btn-expand si-yellow text-white text-left"
                :class="{ active: instructionsExpanded }"
                @click="instructionsExpanded = !instructionsExpanded"
              >
                <h1 class="mb-0 si-font">Instructions</h1>
              </div>
              <div v-if="instructionsExpanded" class="border p-3 rich-text-html">
                <div
                  style="text-align: left"
                  v-html="program.prototype_config.feedback_instructions"
                ></div>
              </div>
            </div>
            <div
              v-if="
                program &&
                program.pitch_config &&
                program.pitch_config.instructions &&
                !context.is_contest &&
                !prototype
              "
              class="col-12"
            >
              <div
                class="btn btn-full-stripe btn-expand si-yellow text-white text-left"
                :class="{ active: instructionsExpanded }"
                @click="instructionsExpanded = !instructionsExpanded"
              >
                <h1 class="mb-0 si-font">Instructions</h1>
              </div>
              <div v-if="instructionsExpanded" class="border p-3 rich-text-html">
                <div
                  style="text-align: left"
                  v-html="program.pitch_config.instructions"
                ></div>
              </div>
            </div>
            <div
              v-if="
                program &&
                program.contest_config &&
                program.contest_config.instructions &&
                context.is_contest &&
                !prototype
              "
              class="col-12"
            >
              <div
                class="btn btn-full-stripe btn-expand si-yellow text-white text-left"
                :class="{ active: instructionsExpanded }"
                @click="instructionsExpanded = !instructionsExpanded"
              >
                <h1 class="mb-0 si-font">Instructions</h1>
              </div>
              <div v-if="instructionsExpanded" class="border p-3 rich-text-html">
                <div
                  style="text-align: left"
                  v-html="program.contest_config.instructions"
                ></div>
              </div>
            </div>
            <div v-if="!prototype">
              <div v-for="cat in rubricCategories" :key="cat.id" class="col-12">
                <div
                  class="btn btn-full-stripe btn-expand si-orange text-white text-left"
                  :class="{ active: cat.expanded, [`si-${cat.color}`]: true }"
                  @click="cat.expanded = !cat.expanded"
                >
                  <h1 class="mb-0 si-font">{{ cat.name }}</h1>
                </div>
                <template v-if="cat.expanded">
                  <p class="text-md text-left h-pad mt-3">
                    {{ cat.prompt }}
                  </p>
                  <h1
                    class="mb-0 si-font text-left h-pad"
                    :class="{ [`si-text-${cat.color}`]: true }"
                  >
                    Progress Criteria
                  </h1>

                  <div class="pl-2 pr-4">
                    <hundred-slider
                      :color="cat.color"
                      :hideNumbers="true"
                      :marks="fs.constructSliderMarks(cat.marks)"
                      v-model="cat.response.score"
                    />
                  </div>
                  <div v-if="!one_reasoning">
                    <h1
                      class="mt-3 si-font text-left h-pad"
                      :class="{ [`si-text-${cat.color}`]: true }"
                    >
                      Progress Feedback
                    </h1>
                    <div class="mb-3 text-muted text-left h-pad">Include at least one strength and one area of improvement.</div>
                    <textarea class="form-control" rows="5" v-model="cat.response.text" />
                  </div>
                </template>
              </div>
            </div>
            <div class="col-12" v-if="one_reasoning">
              <h1
                class="mt-3 si-font text-left h-pad"
                :class="{ [`si-text-${getColor(rubricCategories.length)}`]: true }"
              >
                Progress Feedback
              </h1>
              <div class="mb-3 text-muted text-left h-pad">Include at least one strength and one area of improvement.</div>
              <textarea class="form-control" rows="5" v-model="response" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-slot:footer>
      <div class="col-4 text-right">
          <a
            class="btn btn-si-secondary"
            :href="prototype ? '#/prototypes' : '#/pitches'"
          >
            Cancel
          </a>
          <a
            v-if="showFeedback"
            class="btn ml-3"
            :class="{ 'btn-si-green': ready, 'btn-si-secondary': !ready}"
            @click="submit"
            :disabled="submitting"
          >
            Submit
          </a>
          <button
            v-if="
              !showFeedback &&
              (!context.is_contest || program.contest_config.peer_feedback)
            "
            class="btn btn-si-secondary ml-3"
            @click="showFeedback = !showFeedback"
          >
            Feedback
          </button>
      </div>
    </template>

    <b-modal id="cantSubmitModal" headerClass="indigo">
      <template v-slot:modal-title>
        <h3 class="modal-title full-bar-title">Cannot Submit Pitch Feedback</h3>
      </template>
      <div class="p-2">
        <div v-for="(error, i) in submitErrors" :key="i">
          <div v-if="error.score && error.reasoning" class="text-md">
            <strong :class="{ [`si-text-${getColor(error.seq)}`]: true }">{{
              error.name
            }}</strong>
            requires a rating and explanation
          </div>
          <div v-if="error.score && !error.reasoning" class="text-md">
            <strong :class="{ [`si-text-${getColor(error.seq)}`]: true }">{{
              error.name
            }}</strong>
            requires a rating
          </div>
          <div v-if="error.reasoning && !error.score" class="text-md">
            <strong :class="{ [`si-text-${getColor(error.seq)}`]: true }">{{
              error.name
            }}</strong>
            requires an explanation
          </div>
        </div>
      </div>
      <template v-slot:modal-footer="{ _, cancel }">
        <button type="button" class="btn btn-primary" @click="cancel">Okay</button>
      </template>
    </b-modal>
  </main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import HundredSlider from "@/components/HundredSlider";

import ProgramService from "@/services/ProgramService";
import SectionService from "@/services/SectionService";
import PitchService from "@/services/PitchService";
import RubricService from "@/services/RubricService";
import Notie from "@/services/NotieService";
import BB from "bluebird";
import fs from "@/services/FormatService";
import _ from "lodash";

export default {
  name: "Pitch",

  props: ["user"],

  components: { MainPage, HundredSlider },

  data() {
    var prototype = false;
    if (this.$route.path.includes("/prototype")) {
      prototype = true;
    }

    let teamID = this.$route.params.teamID;
    let assignmentID = this.$route.params.assignmentID;
    let showFeedback = this.$route.query.feedback;

    return {
      fs: fs,
      teamID: teamID,
      assignmentID: assignmentID,
      showFeedback: showFeedback,
      instructionsExpanded: true,

      context: null,
      program: null,
      team: null,
      assignment: null,
      pitch: null,
      rubric: null,
      rubricCategories: null,
      submitErrors: [],
      submitting: false,
      feedbackId: null,

      prototype: prototype,
      response: null,
      one_reasoning: prototype,
    };
  },

  created() {
    this.loadData();
  },

  computed: {
    anyScores() {
      if (this.prototype) {
        return false;
      }
      if (!this.rubric) {
        return false;
      }
      return RubricService.anyScore(this.rubric);
    },

    ready() {
      this.validateSubmit();
      return this.submitErrors.length == 0;
    },
  },

  methods: {
    loadData() {
      BB.props({
        program: ProgramService.getContextProgram(),
        pitch: PitchService.getContextPitch(this.teamID, this.assignmentID),
        context: SectionService.getContextPrefilled(),
      })
        .then((r) => {
          this.pitch = r.pitch.data;
          this.program = r.program.data;
          this.context = r.context.data;
          this.team = _.find(this.context.teams, { id: this.teamID });
          this.assignment = _.find(this.context.pitches.concat(this.context.prototypes), {
            id: this.assignmentID,
          });
          if (this.context.is_contest) {
            this.rubric =
              this.program &&
              this.program.contest_config &&
              this.program.contest_config.rubric;
          } else {
            this.rubric =
              this.program &&
              this.program.pitch_config &&
              this.program.pitch_config.rubric;
          }
          if (
            (!this.context.is_contest && this.program.pitch_config.one_reasoning) ||
            (this.context.is_contest && this.program.contest_config.one_reasoning)
          ) {
            this.one_reasoning = true;
          }
          RubricService.prepForScore(this, this.rubric);
          this.rubricCategories = this.rubric ? this.rubric.categories : [];
          _.each(this.rubricCategories, (cat, i) => {
            this.$set(cat, "expanded", false);
            cat.color = this.getColor(i);
          });

          PitchService.getUserFeedbacks(this.user.id, this.context.id)
            .then((r) => {
              var feedback = _.find(r.data, {
                team_id: this.teamID,
                assignment_id: this.assignment.id,
              });
              if (feedback) {
                this.feedbackId = feedback.id;
                _.each(this.rubricCategories, (cat, i) => {
                  cat.response = feedback.response.responses[i];
                });
                this.response = feedback.response.feedback;
              }
            })
            .catch((e) => {
              console.log(e);
            });

          this.showFeedback =
            this.showFeedback &&
            (!this.context.is_contest ||
              this.user.role != "STUDENT" ||
              this.program.contest_config.peer_feedback);
        })
        .catch((e) => {
          console.log(e);
          Notie.error("Failed to load pitch", e);
        });
    },

    constructFeedback() {
      let feedback = {
        id: this.feedbackId,
        team_id: this.teamID,
        assignment_id: this.assignmentID,
        response: {
          rubric_id: this.rubric.id,
          responses: [],
        },
      };

      _.each(this.rubric.categories, (cat) => {
        feedback.response.responses.push(cat.response);
      });

      if (this.response) {
        feedback.response.feedback = this.response;
      }

      return feedback;
    },

    submit() {
      this.submitting = true;
      this.validateSubmit();
      if (this.submitErrors && this.submitErrors.length > 0) {
        this.$bvModal.show("cantSubmitModal");
        this.submitting = false;
        return;
      }

      let feedback = this.constructFeedback();
      PitchService.submitFeedback(feedback)
        .then(() => {
          Notie.success("Feedback submitted");
          this.$router.push(this.prototype ? "/prototypes" : "/pitches");
        })
        .catch((e) => {
          console.log(e);
          Notie.error("Failed to submit feedback", e);
          this.submitting = false;
        });
    },

    getColor(index) {
      if (index % 2 == 1) {
        return "green";
      }
      if (index % 4 == 0) {
        return "orange";
      }
      if (index % 4 == 2) {
        return "blue";
      }
    },

    validateSubmit() {
      this.submitErrors = [];
      if (!this.prototype) {
        _.each(this.rubricCategories, (rc, i) => {
          let any = false;
          let error = {
            seq: i,
            name: rc.name,
          };
          if (
            rc.required_score &&
            (rc.response.score == null || rc.response.score == undefined)
          ) {
            any = true;
            error.score = true;
          }
          if (rc.required_reasoning && !rc.response.text && !this.one_reasoning) {
            any = true;
            error.reasoning = true;
          }
          if (any) {
            this.submitErrors.push(error);
          }
        });
      }

      if (this.one_reasoning && (this.response == null || this.response == "")) {
        this.submitErrors.push({
          seq: this.rubricCategories.length,
          name: "Progress Feedback",
          reasoning: true,
        });
      }
    },
    isImg(url) {
      console.log("URL", url)
      var base_url = url.split('?')[0];
      console.log("BASE URL", base_url)
      var parts = base_url.split('.');
      var extension = parts[parts.length - 1].toLowerCase();
      console.log("EXTENSION", extension)
      return ['apng', 'avif', 'gif', 'jpeg', 'jpg', 'png', 'svg', 'webp'].includes(extension);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  margin-bottom: 3rem;
}
.content .col-12 {
  margin-top: 3rem;
}

.h-pad {
  padding: 0rem 2rem;
}

.video {
  display: block;
  top: 0;
  margin-left: calc(50% - 640px);
  width: 1280px;
  transition: margin-left 0.5s ease-in-out, width 0.5s ease-in-out;
}
.video.video-right {
  margin-left: calc(50% + 80px);
  width: 560px;
  height: 315px;
}

.description {
  margin-left: calc(50% - 640px);
  width: 1280px;
}

.description.description-right {
  margin-left: calc(50% + 80px);
  width: 560px;
}

.table {
  margin-left: calc(50% + 80px);
  width: 560px;
}
.video-embed {
  width: 1280px;
  height: 720px;
  transition: height 0.5s ease-in-out, width 0.5s ease-in-out;
  border: 0;
}
.image-embed {
  height: 720px;
}
.video.video-right .video-embed {
  width: 560px;
  height: 315px;
}

.feedback {
  display: block;
  width: 700px;
  margin-left: calc(50% - 640px);
  margin-right: 580px;
  opacity: 0;
  transition: opacity 0.5s;
}
.feedback.video-right {
  opacity: 1;
}
.feedback .feedback-wrapper {
  display: none;
}
.feedback.video-right .feedback-wrapper {
  display: block;
}

@media screen and (max-width: 1360px) {
  .video.video-right {
    margin-left: 80px;
    width: 700px;
  }
  .table {
    margin-left: 80px;
    width: 700px;
  }
  .feedback {
    margin-left: 80px;
  }
  .description.description-right {
    margin-left: 80px;
    width: 700px;
  }
}

@media screen and (max-width: 780px) {
  .video {
    margin-left: 0px;
    width: 300px;
  }
  .video.video-right {
    margin-left: 0px;
    width: 100%;
  }
  .table {
    margin-left: 0px;
    width: 100%;
  }
  .feedback {
    margin-left: 0px;
    width: 100%;
  }
  .description.description-right {
    margin-left: 0px;
    width: 100%;
  }
}

@media screen and (min-width: 1360px) {
  .sticky {
    position: -webkit-sticky;
    position: sticky;
    top: 3rem;
    height: 0px;
    width: 100%;
    z-index: 2;
  }
}

textarea {
  border-width: 2px !important;
  border-color: rgb(200, 200, 200) !important;
}

.v-mid {
  vertical-align: middle;
}

td {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
</style>
